import React from "react";
import Lottie from "react-lottie";
import successAnimation from "./images/success.json";
import "./SuccessMessage.scss";

function SuccessMessage() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: successAnimation,
    renderer: "svg",
  };

  return (
    <div styleName="base">
      <span styleName="lottie">
        <Lottie
          options={defaultOptions}
          style={{
            position: "absolute",
            left: "-75%",
            top: "-75%",
            height: "250%",
            width: "250%",
          }}
        />
      </span>
      <div styleName="base-div">
        <p styleName="header">Congratulations!</p>
        <p styleName="header-ttl">
          Your response has been successfully submitted
        </p>

        <div styleName="info-div">
          <p styleName="info-des">
            Your Loan Advisor will reach out to you shortly for further process.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SuccessMessage;
